var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140px",
    height: "140px",
    viewBox: "0 0 140 140",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F6EA4E80-EC54-4F60-998B-002377058E9A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mob-app-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Negative-emotion",
    transform: "translate(-204.000000, -230.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Segmented-Controller---4-Segments-Copy",
    transform: "translate(0.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cards",
    transform: "translate(24.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Productive",
    transform: "translate(172.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alarm-clock_2",
    transform: "translate(8.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6547718,8.42323651 C18.7401623,7.22012658 19.4553921,4.55427022 18.2522822,2.46887967 C17.0491722,0.383489119 14.3833159,-0.331740638 12.2979253,0.871369295 C8.06305988,3.32331898 4.26696131,6.46464699 1.0659751,10.1659751 C-0.403824218,11.9927184 -0.164392149,14.6550482 1.60775636,16.1902325 C3.37990486,17.7254167 6.04917492,17.5828496 7.64771784,15.8676349 C10.216436,12.9038222 13.2603413,10.3880114 16.6547718,8.42323651 L16.6547718,8.42323651 Z",
    id: "Path",
    fill: "#FF8500"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(7.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.3675696,18.8931743 L82.131387,20.1210788 C77.2830229,18.2575592 72.1892487,17.1096009 67.0102252,16.7132988 L67.0102252,8.2780083 L71.1492293,8.2780083 C73.4351382,8.27800826 75.2882334,6.424913 75.2882334,4.13900415 C75.2882334,1.8530953 73.4351382,0 71.1492293,0 L54.5932127,0 C52.3073039,0 50.4542086,1.85309528 50.4542086,4.13900415 C50.4542086,6.42491302 52.3073039,8.2780083 54.5932127,8.2780083 L58.7322169,8.2780083 L58.7322169,16.7132988 C53.5532283,17.1098339 48.4594875,18.2577847 43.611055,20.1210788 L42.3969472,18.8931743 C32.6985978,9.19406293 16.973849,9.19344523 7.27473762,18.8917946 C-2.42437372,28.590144 -2.42499142,44.3148928 7.27335795,54.0140041 L10.664582,57.3941909 C5.23106328,79.2734352 14.0195253,102.219495 32.6785654,114.871162 L26.1748102,126.256183 C25.343824,127.54289 25.2913781,129.183325 26.0384774,130.520485 C26.7855767,131.857646 28.2100605,132.672889 29.7414176,132.640682 C31.2727746,132.606524 32.6606076,131.730342 33.3490841,130.362075 L39.8500799,118.990851 C54.4197218,125.896552 71.3199609,125.896552 85.8896028,118.990851 L92.3878393,130.362075 C93.5812218,132.209921 96.0115282,132.801508 97.9206826,131.708884 C99.829837,130.616261 100.550837,128.221157 99.5621131,126.256183 L93.058358,114.873921 C111.729915,102.230025 120.531268,79.2808471 115.102694,57.3941909 L118.488399,54.0084855 C127.987045,44.2768472 127.892168,28.7156155 118.275565,19.1005234 C108.658961,9.4854313 93.0977151,9.39299943 83.3675696,18.8931743 Z M13.6419057,48.6774481 L13.1259098,48.1614523 C6.86232212,41.8502902 6.70249276,31.7185056 12.7638956,25.2129162 C18.8252985,18.7073268 28.9430838,18.1514252 35.6807231,23.9537967 C25.9326363,29.6910562 18.2257836,38.3367806 13.6419057,48.6774481 L13.6419057,48.6774481 Z M112.633088,48.1614523 L112.117092,48.6774481 C107.534002,38.3362728 99.8269564,29.6903318 90.078275,23.9537967 C96.8159143,18.1514252 106.9337,18.7073268 112.995102,25.2129162 C119.056505,31.7185056 118.896676,41.8502902 112.633088,48.1614523 L112.633088,48.1614523 Z",
    id: "Shape",
    fill: "#FF8500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.186304,69.9132988 L65.186304,48.9423444 C65.186304,47.6683312 64.1535122,46.6355394 62.879499,46.6355394 C61.6054858,46.6355394 60.5726941,47.6683312 60.5726941,48.9423444 L60.5726941,70.8459544 C60.5786218,71.4549477 60.8280304,72.0362387 61.2652874,72.460166 L86.5104534,97.705332 C86.9308446,98.1477302 87.5143823,98.3982033 88.124665,98.3982033 C88.7349477,98.3982033 89.3184854,98.1477302 89.7388766,97.705332 C90.180545,97.284539 90.4305043,96.7011512 90.4305043,96.0911203 C90.4305043,95.4810894 90.180545,94.8977017 89.7388766,94.4769087 L65.186304,69.9132988 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 62.8739804,
    cy: 32.231805,
    r: 3.34431535
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 35.6365737,
    cy: 43.6720124,
    r: 3.34431535
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 24.2791463,
    cy: 70.9839212,
    r: 3.34431535
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 35.6365737,
    cy: 98.2102905,
    r: 3.34431535
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 62.9512418,
    cy: 109.482178,
    r: 3.34431535
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 101.449499,
    cy: 70.9839212,
    r: 3.34431535
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 90.2631505,
    cy: 43.7603112,
    r: 3.34431535
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.647718,10.1659751 C135.445288,6.46497861 131.648296,3.32372369 127.412863,0.871369295 C125.327473,-0.331740638 122.661616,0.383489119 121.458506,2.46887967 C120.255396,4.55427022 120.970626,7.22012658 123.056017,8.42323651 C126.449789,10.3889296 129.492744,12.9057483 132.060166,15.8705394 C133.079188,17.0472923 134.648594,17.5910148 136.177203,17.2968921 C137.705812,17.0027693 138.961392,15.9154855 139.470979,14.4446099 C139.980565,12.9737343 139.66674,11.3427279 138.647718,10.1659751 L138.647718,10.1659751 Z",
    id: "Path",
    fill: "#FF8500"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductive);
export default __webpack_public_path__ + "static/media/productive.5ec9cb20d02d3331409eff750d316db2.svg";
export { ForwardRef as ReactComponent };